module.exports = __webpack_public_path__ + "30ef5917bdf6bffc408c1c43afbf1a70.woff2";